import { GridColDef } from "@mui/x-data-grid";

export type TRowConfiguraDesconto = {
  id: number;
  usuario: string;
  descontoMaximoNoItem: string;
  descontoMaximoNoRodape: string;
  autorizaDesconto: boolean;
};

export type TDataGrid = {
  rows: Array<TRowConfiguraDesconto>;
  columns: Array<GridColDef>;
};

export type TConfigurarDescontosProps = {
  dataGridData: TDataGrid;
};

export enum ConfiguracoesTelas {
  TELA_PRINCIPAL = "Tela_principal",
  CONFIGURAR_DESCONTOS_ACRESCIMOS = "Configurar_descontos_acrescimos",
  CONFIGURAR_MOVIMENTACOES_FISCAIS = "Configurar_movimentacoes_fiscais",
  CONFIGURAR_COBRANCA_TABELAS_PRECO_E_DEPOSITO = "Configurar_cobranca_tabelas_preco_e_deposito",
  CONFIGURAR_POLITICA_DEVOLUCAO = "Configurar_politica_devolucao",
  CONFIGURAR_POLITICA_VENDA = "Configurar_politica_venda",
  CONFIGURAR_CAIXA = "CONFIGURAR_CAIXA",
}

export type TConfiguracoesInitialState = {
  telaAtiva: ConfiguracoesTelas;
};

export type UsuarioTO = {
  username: string;
  uuid: string;
};

export enum ConfiguracoesTitle {
  DESCONTOS_ACRESCIMOS = "Configurar desconto e acréscimo",
  MOVIMENTACOES_FISCAIS = "Configurar movimentações fiscais",
  POLITICA_DEVOLUCAO = "Configurar política de devolução e crédito do cliente",
  COBRANCA_TABELAS_PRECO_E_DEPOSITO = "Configurar cobrança", //, tabelas de preço e depósitos", futuramente será implementado,
  CONFIGURACAO_POLITICA_VENDA = "Configurar política de venda",
  CONFIGURACAO_CAIXA = "Configurar caixa",
}

export type rowGrid = {
  id: string;
  uuid: string | null;
  usuario: string;
  descontoMaximoItem: number;
  descontoMaximoPedido: number;
  acrescimoMaximoPedido: number;
  autorizaDesconto: boolean;
};

export type ConfigurarDescontosInitialState = {
  showAddConfiguracao: boolean;
  rows: Array<rowGrid>;
  usuarios: Array<UsuarioTO>;
  usuariosSelecionados: Array<UsuarioTO>;
  descontoMaximoNoItem: number;
  descontoMaximoPedido: number;
  acrescimoMaximoPedido: number;
  autorizaDesconto: boolean;
  usuarioEdit: rowGrid | null;
  replicaOutrosEstabelecimentos: boolean;
  showConfirmaDelete: boolean;
};

export type ConfiguracaoDescontoTO = {
  uuid: string | null;
  usuario: string;
  descontoMaximoItem: number;
  descontoMaximoPedido: number;
  acrescimoMaximoPedido: number;
  autorizaDesconto: boolean;
};

export enum TipoDescontoAcrescimoAutorizador {
  DESCONTO_ITEM = "DESCONTO_ITEM",
  DESCONTO_PEDIDO = "DESCONTO_PEDIDO",
  ACRESCIMO_PEDIDO = "ACRESCIMO_PEDIDO",
}

export enum TipoDescontoAcrescimoAutorizadorLabelDescritivo {
  DESCONTO_ITEM = "Desconto solicitado no item",
  DESCONTO_PEDIDO = "Desconto solicitado no pedido",
  ACRESCIMO_PEDIDO = "Acréscimo solicitado no pedido",
}

export type ConfiguracaoDescontoDeleteRequestDTO = {
  uuid: string;
  replicaOutrosEstabelecimentos: boolean;
};

export type ConfiguracaoDescontoRequestDTO = {
  configuracoesDescontoTO: Array<ConfiguracaoDescontoTO>;
  replicaOutrosEstabelecimentos: boolean;
};
